// Serviço de API para Events
import { apiRequest } from '@/services/queryClient';
import { getApiBaseUrl } from '@/config/production';
import type { Event } from '@/types/schema';
import type {
    EventFilters,
    EventsResponse,
    EventCreateRequest,
    EventUpdateRequest
} from '../models/event.types';

const API_BASE = `${getApiBaseUrl()}/api`;

export class EventService {
    // Buscar todos os eventos com filtros
    static async getAll(filters: EventFilters = {}): Promise<EventsResponse> {
        const params = new URLSearchParams();

        if (filters.page) params.append('page', filters.page.toString());
        if (filters.limit) params.append('limit', filters.limit.toString());
        if (filters.status && filters.status !== 'all') params.append('status', filters.status);
        if (filters.searchTerm) params.append('search', filters.searchTerm);
        if (filters.category && filters.category !== 'all') params.append('category', filters.category);
        if (filters.location && filters.location !== 'all') params.append('location', filters.location);
        if (filters.dateFrom) params.append('dateFrom', filters.dateFrom);
        if (filters.dateTo) params.append('dateTo', filters.dateTo);

        const url = `${API_BASE}/events?${params}`;
        // console.log('🔍 [EventService] Fazendo requisição para:', url);
        // console.log('🔍 [EventService] Filtros:', filters);

        const response = await apiRequest('GET', url);
        const data = await response.json();

        // console.log('📡 [EventService] Resposta da API:', data);

        const result = {
            events: data.data || data.events || [],
            total: data.count || data.total || 0,
            page: filters.page || 1,
            limit: filters.limit || 10
        };

        // console.log('✅ [EventService] Resultado processado:', result);
        return result;
    }

    // Buscar evento por ID
    static async getById(id: string): Promise<Event> {
        const response = await apiRequest('GET', `${API_BASE}/events/${id}`);
        const data = await response.json();
        return data.data || data;
    }

    // Criar novo evento
    static async create(eventData: EventCreateRequest): Promise<Event> {
        const response = await apiRequest('POST', `${API_BASE}/events`, eventData);
        const data = await response.json();
        return data.data || data;
    }

    // Atualizar evento
    static async update(id: string, eventData: Partial<EventCreateRequest>): Promise<Event> {
        const response = await apiRequest('PUT', `${API_BASE}/events/${id}`, eventData);
        const data = await response.json();
        return data.data || data;
    }

    // Deletar evento
    static async delete(id: string): Promise<void> {
        await apiRequest('DELETE', `${API_BASE}/events/${id}`);
    }

    // Upload de imagem de capa
    static async uploadCoverImage(file: File): Promise<{ url: string }> {
        const formData = new FormData();
        formData.append('file', file);

        const response = await apiRequest('POST', `${API_BASE}/events/upload/cover`, formData);
        const data = await response.json();
        return data.data || data;
    }

    // Deletar imagem de capa
    static async deleteCoverImage(url: string): Promise<void> {
        await apiRequest('DELETE', `${API_BASE}/events/upload/cover`, { url });
    }
}

